import * as api from "../api";

export const CampaignService = {
  createAdminFlashCampaign,
  createAdminBulkCampaign,
  createParentFlashCampaign,
  createParentBulkCampaign,
  createAdminContactListFlashCampaign,
  createAdminContactListBulkCampaign,
  createAdminPersonalizedCampaign,
  createParentContactListFlashCampaign,
  createParentContactListBulkCampaign,
  createParentPersonalizedCampaign,
  updateCampaignDetails,
  changeCampaignStatus,
  getCampaignCreatedNumberList
};

async function createParentPersonalizedCampaign(formData) {
  try {
    const { data } = await api.createParentPersonalizedCampaign(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createParentContactListBulkCampaign(formData) {
  try {
    const { data } = await api.createParentContactListBulkCampaign(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createParentContactListFlashCampaign(formData) {
  try {
    const { data } = await api.createParentContactListFlashCampaign(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createAdminPersonalizedCampaign(formData) {
  try {
    const { data } = await api.createAdminPersonalizedCampaign(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createAdminContactListBulkCampaign(formData) {
  try {
    const { data } = await api.createAdminContactListBulkCampaign(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createAdminContactListFlashCampaign(formData) {
  try {
    const { data } = await api.createAdminContactListFlashCampaign(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createAdminFlashCampaign(formData) {
  try {
    const { data } = await api.createAdminFlashCampaign(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createAdminBulkCampaign(formData) {
  try {
    const { data } = await api.createAdminBulkCampaign(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateCampaignDetails(formData) {
  try {
    const { data } = await api.updateCampaignDetails(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createParentFlashCampaign(formData) {
  try {
    const { data } = await api.createParentFlashCampaign(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function changeCampaignStatus(formData) {
  try {
    const { data } = await api.changeCampaignStatus(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createParentBulkCampaign(formData) {
  try {
    const { data } = await api.createParentBulkCampaign(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getCampaignCreatedNumberList(formData) {
  try {
    const { data } = await api.getCampaignCreatedNumberList(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}
